<template>
    <canvas ref="canvas" width="320" height="240"></canvas>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: {
        datasets: {
            type: Array,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
        axes: {
            type: Object,
            default() {
                return {
                    x: null,
                    y: null
                }
            }
        }
    },
    mounted() {
        let axes = {
            xAxes: [{
                display: this.axes.x !== null,
                scaleLabel: {
                    display: this.axes.x !== null,
                    labelString: this.axes.x
                }
            }],
            yAxes: [{
                display: this.axes.y !== null,
                scaleLabel: {
                    display: this.axes.y !== null,
                    labelString: this.axes.y
                }
            }]
        }

        this.chart = new Chart(this.$refs.canvas.getContext('2d'), {
            type: 'line',
            data: {
                labels: this.labels,
                datasets: this.datasets
            },
            options: {
                responsive: true,
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: axes
            }
        })
    }
}

</script>